import { jsx as _jsx } from "react/jsx-runtime";
import { validateReviewers } from '~/business-logic/draftLogic';
import { allReviewersComplete } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/utils/isCompleteReviewer';
import { draftClientId } from '../draftClient.utils';
import { ClientAdditionalRecipientsModalContent } from './ClientAdditionalRecipientsModalContent/ClientAdditionalRecipientsModalContent';
const MODAL_WIDTH = '800px';
export const recipientsCellAvailability = (param)=>{
    let { draft, contact, isDisabled, disabledTooltip, draftCellsTexts } = param;
    if (isDisabled) {
        return {
            isDisabled,
            disabledTooltip
        };
    }
    if (draft.isSample()) {
        return {
            isDisabled: true,
            disabledTooltip: draftCellsTexts.additionalRecipientsSampleDisabled()
        };
    }
    if (draftClientId(draft, contact) == null) {
        return {
            isDisabled: true,
            disabledTooltip: draftCellsTexts.additionalRecipientsRequiresClient()
        };
    }
    return {
        isDisabled: false,
        disabledTooltip: undefined
    };
};
const renderClientAdditionalRecipientsModal = (param)=>{
    let { draft, setDraft, wasSubmitted, title, testId } = param;
    return {
        title,
        testId,
        onSubmit: (defaultBehavior)=>void defaultBehavior(),
        content: /*#__PURE__*/ _jsx(ClientAdditionalRecipientsModalContent, {
            draft: draft,
            setDraft: setDraft,
            showReviewerErrors: wasSubmitted
        })
    };
};
export const clientAdditionalRecipientsModalOptions = (param)=>{
    let { title, testId, primaryContact, validationTexts, validators } = param;
    return {
        width: MODAL_WIDTH,
        shouldSubmit: (editedDraft)=>Promise.resolve(allReviewersComplete(editedDraft.reviewers()) && validateReviewers({
                allReviewers: editedDraft.reviewers(),
                primaryContact,
                texts: validationTexts,
                validators
            })),
        renderContent: (param)=>{
            let { wasSubmitted, draft, setDraft } = param;
            return renderClientAdditionalRecipientsModal({
                draft,
                setDraft,
                wasSubmitted,
                title,
                testId
            });
        }
    };
};
